import { z } from "zod";
import { ClientId, DateSchema } from "../../Types";
import { GoalBasedFinancialPlanAccountResponseSchema } from "../account/types";
import { GoalBasedFinancialPlanExpenseResponseSchema } from "../expenses/types";
import { GoalBasedFinancialPlanGoalResponseSchema } from "../goals/types";
import { GoalBasedFinancialPlanIdSchema } from "../ids";
import { GoalBasedFinancialPlanIncomeResponseSchema } from "../income/types";
import { GoalBasedFinancialPlanInsuranceResponseSchema } from "../insurance/types";
import { GoalBasedFinancialPlanRetirementHorizonResponseSchema } from "../retirementHorizon/types";
import { GoalBasedFinancialPlanSavingsResponseSchema } from "../savings/types";
const GoalBasedFinancialPlanStatuses = ["Incomplete", "Complete"];
export const GoalBasedFinancialPlanStatus = z.enum(GoalBasedFinancialPlanStatuses);
export const GoalBasedFinancialPlanPostRequestSchema = z.object({
    owner: ClientId,
    name: z.string(),
});
export const GoalBasedFinancialPlanResponseSchema = z.object({
    goalBasedFinancialPlanId: GoalBasedFinancialPlanIdSchema,
    name: z.string(),
    owner: ClientId,
    status: GoalBasedFinancialPlanStatus,
    isFavorite: z.boolean(),
    createdAt: DateSchema,
    updatedAt: DateSchema,
});
export const GoalBasedFinancialPlansArrayResponseSchema = GoalBasedFinancialPlanResponseSchema.array();
export const GoalBasedBaseFinancialPlanPatchRequestSchema = z.object({
    name: z.string().optional(),
    status: GoalBasedFinancialPlanStatus.optional(),
    isFavorite: z.boolean().optional(),
});
export const GoalBasedFinancialPlanDeleteResponseSchema = z.object({
    message: z.string(),
    owner: ClientId,
});
export const GoalBasedFinancialPlanSingleResponseSchema = GoalBasedFinancialPlanResponseSchema.extend({
    goals: GoalBasedFinancialPlanGoalResponseSchema.array(),
    accounts: GoalBasedFinancialPlanAccountResponseSchema.array(),
    income: GoalBasedFinancialPlanIncomeResponseSchema.array(),
    savings: GoalBasedFinancialPlanSavingsResponseSchema.array(),
    expenses: GoalBasedFinancialPlanExpenseResponseSchema.array(),
    insurance: GoalBasedFinancialPlanInsuranceResponseSchema.array(),
    retirementHorizon: GoalBasedFinancialPlanRetirementHorizonResponseSchema.array(),
});
//# sourceMappingURL=types.js.map